import gql from 'graphql-tag'

const upgradeTypeQuery = gql`
  query UpgradeType {
    upgradeType @client
  }
`

export default upgradeTypeQuery
